'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * InspectionSchedule — the thin standalone screen (#/InspectionSchedule[/:View]) that hosts the program-level asset
 * inspection schedule (Year / Month / Week / Agenda). The InspectionSchedule provider paints the whole screen into
 * #InspectionSchedule-Host. Full browser width via Dashboard Mode. See [[InspectionSchedule-Provider.js]].
 */
class InspectionScheduleView extends libPictView
{
	get provider() { return this.pict.providers['InspectionSchedule']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider)
		{
			tmpProvider._mount = '#InspectionSchedule-Host';
			tmpProvider.loadAsync();
		}
		return super.onAfterRender(pRenderable);
	}
}

module.exports = InspectionScheduleView;

module.exports.default_configuration =
{
	ViewIdentifier: 'InspectionSchedule',
	DefaultRenderable: 'InspectionScheduleWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.isc-page { padding: 1.25rem 2rem 2rem; }
		.isc-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.isc-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.isc-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'InspectionSchedule-Template',
			Template: html`
				<section class="section isc-page">
					<h1 class="isc-page-h"><i class="fas fa-calendar-check"></i> Inspection Schedule</h1>
					<p class="isc-page-sub">Plan and run the inspection program — every scheduled and dynamic asset inspection, by year, month, week, or agenda.</p>
					<div id="InspectionSchedule-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'InspectionScheduleWrap',
			TemplateHash: 'InspectionSchedule-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
